/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactComponentElement } from 'react'

type Props = {
  children: ReactComponentElement<any>
}

function PublicLayout({ children }: Props) {
  return (<div className='w-full h-full'>{children}</div>)
}

export default PublicLayout